import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M7.40323 18.425L5.99023 17.01L12.0002 10.999L18.0102 17.01L16.5972 18.423L11.9972 13.823L7.39723 18.423L7.40323 18.425ZM7.40323 13.001L5.99023 11.585L12.0002 5.57501L18.0102 11.585L16.5972 12.999L11.9972 8.39901L7.39723 12.999L7.40323 13.001Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "ChevronDuoUp"
);
